import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import SEOHead from '../components/SEOHead';

const Privacy = () => {
  return (
    <>
      <SEOHead
        title="Privacy Policy"
        description="ParadoxEdge privacy policy. Learn how we collect, use, and protect your personal information."
        canonicalUrl="/privacy"
        keywords="privacy policy, data protection, personal information"
      />
      <div className="min-h-screen bg-background">
        <Navigation />
        <main className="container-mobile py-12 sm:py-16">
          <div className="max-w-3xl mx-auto">
            <h1 className="text-primary text-2xl sm:text-3xl font-bold mb-8">Privacy Policy</h1>
            
            <div className="space-y-6 text-foreground/90">
              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">Information We Collect</h2>
                <p className="text-base leading-relaxed">
                  We collect information that you provide directly to us, including name, email address, and other contact details when you register for our services or communicate with us. We also automatically collect certain information about your device when you use our services, including IP address, browser type, and cookies.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">How We Use Your Information</h2>
                <p className="text-base leading-relaxed">
                  We use the information we collect to provide, maintain, and improve our services, communicate with you, and comply with legal obligations. We retain your personal information for as long as necessary to provide our services and comply with our legal obligations. You may request deletion of your personal information at any time.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">Cookies and Tracking</h2>
                <p className="text-base leading-relaxed">
                  We use cookies and similar tracking technologies to track activity on our website and hold certain information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">Your Rights</h2>
                <p className="text-base leading-relaxed">
                  You have the right to access, update, or delete your personal information. You can also object to processing of your personal information, ask us to restrict processing of your personal information, or request portability of your personal information.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">Information Sharing</h2>
                <p className="text-base leading-relaxed">
                  We do not sell or rent your personal information to third parties. We may share your information with service providers who assist us in delivering our services, or when required by law.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">Data Security</h2>
                <p className="text-base leading-relaxed">
                  We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, or destruction. Despite our safeguards, no security system is impenetrable and we cannot guarantee the security of our systems 100%.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">International Transfers</h2>
                <p className="text-base leading-relaxed">
                  Your information may be transferred to, and maintained on, computers located outside of your state, province, country, or other governmental jurisdiction where the data protection laws may differ.
                </p>
              </section>

              <section>
                <h2 className="text-xl font-semibold mb-4 text-primary">Contact Us</h2>
                <p className="text-base leading-relaxed">
                  If you have any questions about this Privacy Policy, please contact us at support@paradoxedge.com
                </p>
              </section>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default Privacy;
